import { render } from "./EditEtudiantPage.vue?vue&type=template&id=6b1e9a33&ts=true"
import script from "./EditEtudiantPage.vue?vue&type=script&lang=ts"
export * from "./EditEtudiantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__